import React from 'react'
import Link from '@material-ui/core/Link'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Chart from 'react-apexcharts'
import Grid from '@material-ui/core/Grid'

const useStyles = makeStyles({
    depositContext: {
        flex: 1,
    },
    info: {
        marginTop: '25px',
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '16px',
        '&::before': {
            content: `'aa'`,
            width: '15px',
            height: '15px',
            backgroundColor: '#00AAD0',
            marginRight: '8px',
            borderRadius: '50%',
            color: 'transparent',
        },
    },
})

const options = {
    chart: {
        type: 'bar',
        height: 500,
        sparkline: {
            enabled: true,
        },
    },
    plotOptions: {
        bar: {
            horizontal: true,
        },
    },
    dataLabels: {
        enabled: true,
        textAnchor: 'start',
        style: {
            colors: ['#fff'],
        },
        formatter: function(val, opt) {
            return val + ' min'
        },
        dropShadow: {
            enabled: true,
        },
    },
    xaxis: {
        reversed: true,
        labels: {
            show: true,
            style: {
                colors: ['#FEFEFE'],
                fontSize: '12px',
                fontFamily: 'Montserrat',
                fontWeight: 300,
                cssClass: 'apexcharts-yaxis-label',
            },
        },
    },
    grid: {
        xaxis: {
            lines: {
                show: false,
            },
        },
        yaxis: {
            lines: {
                show: false,
            },
        },
    },
    yaxis: {
        reversed: true,
        labels: {
            show: true,
            style: {
                colors: ['#FEFEFE'],
                fontSize: '12px',
                fontFamily: 'Montserrat',
                fontWeight: 300,
                cssClass: 'apexcharts-yaxis-label',
            },
        },
    },
    tooltip: {
        y: {
            formatter: function(val) {
                return val.toFixed(2) + ' min';
            },
        },
        theme: 'dark'
    },
}

export default function BarTimeApps(props) {
    const classes = useStyles()

    if (props.categories) {
        options.xaxis.categories = props.categories
        //oo.xaxis.categories = ['RSSI', 'RSRQ', 'RSRP', 'Roaming', 'VoLTE', 'MobileData']
    }

    const info = [2, 1, 0, 10, 3, 1]

    const series = [{
        data: props.data,
    }]


    return (
        <React.Fragment>
            <Typography component='h2' variant='h6'>
                {props.title}
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs container direction='column' spacing={2}>
                    <Grid item>
                        {
                            props.categories.map((item, key) => {
                                return (
                                    <div key={'' + key}>
                                        <p className={classes.info}>{`${item}`}</p>
                                    </div>
                                )
                            })
                        }
                    </Grid>
                </Grid>
                <Grid item xs={8}>
                    {props.data &&
                        <Chart
                            options={options}
                            height={500}
                            series={series}
                            type='bar'
                        />
                    }
                </Grid>
            </Grid>
        </React.Fragment>
    )
}